import { DeleteIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { useRef } from 'react';
import { useTranslations } from 'use-intl';

import { formatDate } from '@blockpulse3/helpers';

import { DeleteConfirmModal } from '../DeleteConfirmModal';

type Props = {
  title: string;
  children: React.ReactNode;
  date?: Date;
  isDeletable?: boolean;
  onDelete?: () => void;
};
export function Comment({ title, children, date, isDeletable, onDelete }: Props): JSX.Element {
  const i18nComments = useTranslations('Comments');

  const confirmRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleDelete = (): void => {
    if (!onDelete) return;

    onDelete();
    onClose();
  };

  return (
    <>
      <Box
        color="gray.700"
        flex="1"
        fontSize="xs"
        w="100%"
        _hover={{
          '*>.ibtn-delete': { opacity: 1 },
        }}
      >
        <Stack spacing="1">
          <Flex justifyContent="space-between">
            <Text fontSize="sm" fontWeight="600">
              {title}
            </Text>
            {isDeletable && onDelete && (
              <IconButton
                aria-label="add-comment"
                className="ibtn-delete"
                icon={<DeleteIcon color="red.500" />}
                opacity={0}
                size="xs"
                variant="ghost"
                onClick={onOpen}
              />
            )}
          </Flex>
          <Box bg="gray.100" borderRadius="0 8px 8px 8px" fontSize="sm" p="3">
            {children}
          </Box>
          <Text color="gray.500" ml="auto">
            {formatDate(date, 'DD/MM/YYYY HH:mm')}
          </Text>
        </Stack>
      </Box>
      <DeleteConfirmModal
        isOpen={isOpen}
        leastDestructiveRef={confirmRef}
        subtitle={i18nComments('ConfirmModal.SubTitle')}
        title={i18nComments('ConfirmModal.Title')}
        onClose={onClose}
        onDelete={handleDelete}
      />
    </>
  );
}
